<div [formGroup]="control.fg">
  <div class="col-12 col-lg-12 sub-accordion-title">{{ title }}</div>

  <ng-container *ngFor="let i of numbers">
    <div class="form-check form-check-inline">
      <input [id]="control.fcn + '_' + i" type="radio" class="form-check-input" [formControlName]="control.fcn" [value]="values[i]" />
      <label [for]="control.fcn + '_' + i" class="form-check-label">{{ labels[i] }}</label>
    </div>
  </ng-container>
</div>
